import { makeStyles } from '@material-ui/core'

const useInUsaStyles = makeStyles((theme) => {
    const mobileBreakpoint = theme.breakpoints.down('sm')
    return {
        inUsaWrapper: {
            width: '100%',
            maxWidth: '1441px',
            minHeight: 'calc(100vh - 207px)',
            margin: '0 auto',
            marginBottom: 0,
            padding: '24px 88px',
            display: 'flex',
            alignItems: 'center',
            boxSizing: 'border-box',
            [mobileBreakpoint]: {
                minHeight: 'auto',
                padding: '24px',
                alignItems: 'flex-start'
            }
        },
        formWrapper: {
            width: '100%',
            maxWidth: '576px',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: '32px',
            position: 'relative',
            zIndex: 1
        },
        title: {
            width: '100%',
            margin: 0,
            color: 'var(--neutrals-grey-900, #212121)',
            fontFamily: 'Roboto',
            fontSize: '24px',
            fontStyle: 'normal',
            fontWeight: 500,
            lineHeight: '34px',
            [mobileBreakpoint]: {
                width: '100%'
            }
        },
        screeningForm: {
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-end',
            gap: '40px'
        },
        questionGroup: {
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: '24px'
        },
        questionTitle: {
            width: '100%',
            margin: 0,
            color: 'var(--neutrals-grey-900, #212121)',
            fontFamily: 'Roboto',
            fontSize: '20px',
            fontStyle: 'normal',
            fontWeight: 500,
            lineHeight: '28px'
        },
        inputCompanyName: {
            width: '100%',
            '& .MuiOutlinedInput-root': {
                height: '48px',
                borderRadius: '4px',
                backgroundColor: '#FFFFFF',
                '& fieldset': {
                    border: '1px solid #9E9E9E',
                    borderRadius: '4px'
                },
                '&:hover fieldset': {
                    border: '1px solid #9E9E9E'
                },
                '&.Mui-focused fieldset': {
                    border: '2px solid var(--teal-blue, #007DB8)'
                }
            },
            '& .MuiOutlinedInput-input': {
                padding: '13px 12px 13px 16px',
                fontFamily: 'Roboto',
                fontSize: '16px',
                lineHeight: '22px'
            },
            '& .MuiInputLabel-sizeSmall:not(.MuiInputLabel-shrink)': {
                transform: 'translate(16px, 13px) scale(1)'
            },
            '& .MuiInputLabel-root.Mui-focused': {
                color: 'var(--teal-blue, #007DB8)'
            },
            [mobileBreakpoint]: {
                width: '100%'
            }
        },
        radio: {
            width: '100%',
            overflow: 'hidden',
            border: '1px solid #E0E0E0',
            borderRadius: '4px',
            backgroundColor: '#FFFFFF',
            '& .MuiFormControlLabel-root': {
                width: '100%',
                margin: 0,
                padding: '8px 16px',
                columnGap: '16px',
                boxSizing: 'border-box'
            },
            '& .MuiFormControlLabel-root:not(:last-child)': {
                borderBottom: '1px solid #E0E0E0'
            },
            '& .MuiRadio-root': {
                padding: 0
            },
            '& .MuiSvgIcon-root': {
                width: '24px',
                height: '24px'
            },
            '& .MuiFormControlLabel-label': {
                color: '#212121',
                fontFamily: 'Roboto',
                fontSize: '14px',
                fontWeight: 500,
                lineHeight: '20px'
            },
            [mobileBreakpoint]: {
                width: '100%'
            }
        },
        continueBtn: {
            width: '150px',
            minWidth: '150px',
            height: '30px',
            padding: '8px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            alignSelf: 'flex-end',
            borderRadius: '4px',
            backgroundColor: 'var(--teal-blue, #007DB8)',
            color: 'var(--white, #FFFFFF)',
            fontFamily: 'Roboto',
            fontSize: '14px',
            fontStyle: 'normal',
            fontWeight: 500,
            lineHeight: '20px',
            textAlign: 'center',
            textTransform: 'none',
            boxShadow: 'none',
            '&:hover': {
                backgroundColor: 'var(--teal-blue, #007DB8)',
                boxShadow: 'none'
            },
            '&.Mui-disabled': {
                backgroundColor: 'var(--neutrals-grey-300, #E0E0E0) !important',
                color: 'var(--neutrals-grey-600, #757575) !important',
                boxShadow: 'none'
            },
            [mobileBreakpoint]: {
                width: '100%',
                minWidth: '100%',
                alignSelf: 'stretch'
            }
        },
        root: {
            [mobileBreakpoint]: {
                backgroundImage: 'none !important'
            }
        },
        trapezoidBgInUsa: {
            position: 'relative',
            zIndex: 1,
            '&::before': {
                content: '""',
                background: 'linear-gradient(234deg, #005C82 28.58%, #0B9EDB 99.46%)',
                position: 'absolute',
                top: '0',
                left: '0',
                width: '100%',
                height: '100%',
                clipPath: 'polygon(95% 0, 100% 0, 100% 100%, 37.5% 100%)',
                backgroundSize: 'cover'
            }
        }
    }
})

export default useInUsaStyles
